module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-btn-fill-747d39bb.svg";